import axios from 'axios'
import { alert } from "devextreme/ui/dialog"
const baseUri = "WebApi.asmx/api/UserService";
const store = {};
const mutations = {

    GET_USERLIST_FOR_GROUP(state, posts) {
        state.userListForGroup = posts;
    },
    GET_USERLIST_FOR_CREATE(state, posts) {
        state.userListForCreate = posts;
    },
    SET_USER_LIST(state, posts) {
        state.userList = posts;
        state.userListIsLoading = false;
    } 
};
const state = {
    userListIsLoading: false,
    userList: [],
    userListForGroup: [],
    userListForCreate: [],
};
const getters = {};
const actions = {
    getUserList({ commit }) {
        state.userListIsLoading = true;
        axios
            .get(baseUri + '/GetList')
            .then(res => {
                if (res.data.success == true) {
                    commit('SET_USER_LIST', res.data.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    getUserListForGroup({ commit }, { grpId }) {
        return axios
            .get(baseUri + '/GetList', { params: { grpId } })
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_USERLIST_FOR_GROUP', res.data.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
                return res.data;
            });
    },
    getUserListForCreate({ commit }, { ttyId }) {
        return axios
            .get(baseUri + '/GetUserListForCreate', { params: { ttyId } })
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_USERLIST_FOR_CREATE', res.data.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
                return res.data;
            });
    },
    createAvatarIfMissing( ) {
        return axios
            .get(baseUri + '/CreateAvatarIfMissing');
    },
};


export default {
    state,
    store,
    mutations,
    getters,
    actions
}